import React, { Component } from 'react';

import css from './NewsletterPanel.css';
import { FormattedMessage } from '../../util/reactIntl';
import { PrimaryButton } from '../Button/Button';
import ExternalLink from '../ExternalLink/ExternalLink';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const newsDE = "https://blog.socialbnb.org/de/newsletter-de";
const newsEN = "https://blog.socialbnb.org/newsletter-eng";

const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class NewsletterPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      responseHidden: true,
      name: '',
      lastName: '',
      email: '',
      conditions: false,
      submitted: false,
    };

    this.onNameChange = this.onNameChange.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onConditionChange = this.onConditionChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onConditionChange(e) {
    console.log(this.state.conditions);
    this.setState({
      conditions: !this.state.conditions,
    });
    console.log(this.state.conditions);
  }
  onNameChange(e) {
    this.setState({
      name: e.target.value,
    });
  }

  onEmailChange(e) {
    this.setState({
      email: e.target.value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({
      submitted: true,
    });

    if (re.test(this.state.email)) {
      // const name = this.state.name;

      this.setState({
        responseHidden: false,
      });
    }
  }

  render() {
    
    

    return (
      <div>
        {/* target="_blank" */}
        <ExternalLink href={cookies.get('language') === 'en' ? newsEN : newsDE}>
          <PrimaryButton
            type="submit"
            className={
              css.submitButton
            }
          >
            <FormattedMessage id="newsletter.signUp"></FormattedMessage>
          </PrimaryButton>
        </ExternalLink>

        {/* </form> */}
        <div className={this.state.responseHidden ? css.hidden : css.response}>
          <FormattedMessage id="newsLetter.message" />
        </div>
      </div>
    );
  }
}

export default NewsletterPanel;
